import React, { Component } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";
import CompareScene from "../../utils/CompareScene";
import "./CompareCanvas.css";

class CompareCanvas extends Component {
  constructor() {
    super();
    this.state = {};
  }

  getCanvasWrapper = () => {
    return document.getElementById(
      `${
        this.props.containerType === "leftContainer"
          ? "compare-canvas-container--left-3d"
          : "compare-canvas-container--right-3d"
      }`
    );
  }

  getCanvas = () => {
     return document.getElementById(
       `${
         this.props.containerType === "leftContainer"
           ? "3d-compare-canvas--left"
           : "3d-compare-canvas--right"
       }`
     );
  }

  componentDidMount() {
    const canvasWrapper = this.getCanvasWrapper();
    const canvas = this.getCanvas();

    const compareScene = new CompareScene(canvasWrapper, canvas, this.props.image3dUrl);
    compareScene.init(this.props.image3dUrl);
  }


  render() {
    return (
      <div
        className="compare-canvas-3d-container" 
        id={`${
          this.props.containerType === "leftContainer"
            ? "compare-canvas-container--left-3d"
            : "compare-canvas-container--right-3d"
        }`}
        style={
          this.props.containerType === "leftContainer"
            ? this.props.unstated.state.leftApartmentStyles.D3
            : this.props.unstated.state.rightApartmentStyles.D3
        }
      >
        <canvas
          id={`${
            this.props.containerType === "leftContainer"
              ? "3d-compare-canvas--left"
              : "3d-compare-canvas--right"
          }`}
          className="compare-canvas-3d"
        />
      </div>
    );
  }
}

const CompareCanvasWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated =>  <CompareCanvas {...props} unstated={unstated} /> }
    </Subscribe>
  );
};

export default CompareCanvasWithUnstated;
